import classNames from "classnames";
import css from "PFComponents/dropdown/dropdown.module.scss";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { MouseEvent, useEffect, useRef } from "react";

import { DropdownOption } from "./dropdown";

interface DropDownItemProps {
  selected?: boolean;
  hovered?: boolean;
  value: DropdownOption;
  handleChange: (item: any) => void;
  dropDownItemClassName?: string;
  tooltipMsg?: string;
  highlightSelected?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
}

export const DropDownItem = ({
  selected = false,
  hovered = false,
  value,
  handleChange,
  dropDownItemClassName,
  tooltipMsg,
  highlightSelected = true,
  onKeyDown
}: DropDownItemProps) => {
  const itemRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (hovered && itemRef.current) {
      itemRef.current.scrollIntoView({ block: "nearest" });
    }
  }, [hovered]);

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();

    handleChange(value.item);
  };

  const isDisplayElementString = typeof value.displayElement === "string";
  const buttonTitle = isDisplayElementString ? value.displayElement : value?.item?.text;
  const ariaLabel = value.ariaLabel || buttonTitle;
  const displayElement =
    typeof value.displayElement === "string" ? (
      <Typography variant="bodyRegular" textOverflow="clip">
        {value.displayElement}
      </Typography>
    ) : (
      value.displayElement
    );

  return (
    <li ref={itemRef}>
      <Tooltip content={tooltipMsg} disabled={!tooltipMsg}>
        {({ ref, getReferenceProps }) => (
          <div
            ref={ref}
            data-dropdown-item="true"
            {...getReferenceProps({
              "tabIndex": -1,
              "role": "menuitem",
              "aria-label": ariaLabel,
              "aria-current": selected,
              "aria-disabled": value.disabled,
              "title": buttonTitle,
              "className": classNames(css.item, dropDownItemClassName, {
                [css.selected]: (selected && highlightSelected) || hovered,
                [css.disabled]: value.disabled
              }),
              "onClick": handleClick,
              "onKeyDown": onKeyDown
            })}
          >
            {displayElement}
          </div>
        )}
      </Tooltip>
    </li>
  );
};
